import React from 'react'
import { renderRichText } from './marketing/RichTextRenderer'
import NextImage from 'next/image'
import { TextWithImages as TextWithImagesTypes } from 'types/generated/contentful'

interface TextWithImagesProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  entry: TextWithImagesTypes
}

export default function TextWithImages({
  entry,
  className,
  ...props
}: TextWithImagesProps): JSX.Element | null {
  const { text, imagesCollection } = entry
  const { items } = imagesCollection || {}

  return items && text ? (
    <div
      className={`py-20 my-30 md:py-30 bg-neutral-7 w-screen ml-[calc((100vw-100%)/2*-1)] ${
        className || ''
      }`}
      {...props}
    >
      <div className='text-with-images horizontal-padding max-w-screen-2xl mx-auto grid gap-10 lg:grid-cols-2 lg:gap-16'>
        <div>{renderRichText(text)}</div>

        <div className='grid gap-6 md:gap-8'>
          {items.map(
            (image, index) =>
              image?.url &&
              image.width &&
              image.height &&
              image.title && (
                <div key={`${image.title}-${index}`}>
                  <NextImage
                    src={image.url}
                    width={image.width}
                    height={image.height}
                    alt={image.title}
                  />
                  <small className='block mt-3 text-neutral-60'>
                    {image.title}
                  </small>
                </div>
              ),
          )}
        </div>
      </div>
    </div>
  ) : null
}
